import React from 'react';
import { LoadingSpinnerProps } from '../../types';
import './styles.css';

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message = 'Loading...', 
  size = 'medium',
  className = '',
  testId
}) => {
  return (
    <div 
      className={`loading-container ${size} ${className}`} 
      data-testid={testId}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div 
        className="spinner"
        aria-hidden="true"
      />
      {message && (
        <p className="loading-message">
          {message}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner; 